import { useCallback, useEffect, useState } from 'react';
import { useAIChat } from './useAIChat.jsx';
import { postAIChat } from '../api/request.js';
import { useParams } from 'react-router-dom';

const useChatCore = () => {
  const proId = useParams().projectId;
  const [ quesText, setQuesText ] = useState('');
  const [ question, setQuestion] = useState('');
  const { loading, sessionId, setSessionId, pushChatList, setLoading, setIsRetryAsk, setChatList } = useAIChat();

  const inputValChange = (event) => {
    const val = event.target.value;
    setQuesText(val);
  };

  const callAiAsk = useCallback(async () => {
    if(!question) return;
    setIsRetryAsk(false);
    try {
      let params = {};
      params = {
        query: question,
        session_id: sessionId,
        project_id: proId
      };
      const result = await postAIChat(params);
      if(result.status === 'Success') {
        const { sessionId } = result.data;
        pushChatList('answer', result.data);
        setSessionId(sessionId);
        setQuestion('');
      } else {
        setIsRetryAsk(true);
      }
    } catch(error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [pushChatList, setLoading, setSessionId, setIsRetryAsk, sessionId, question, proId]);

  useEffect(() => {
    if(loading) {
      callAiAsk();
    }
  }, [loading, callAiAsk]);

  const onSend = useCallback((initQuestion = '') => {
    let tempQuesText = initQuestion || quesText;
    if(!tempQuesText || loading) return;
    pushChatList('question', tempQuesText);
    setQuestion(tempQuesText);

    setQuesText('');
    setLoading(true);
  }, [pushChatList, setLoading, quesText, loading]);

  const onRefresh = () => {
    setQuesText('');
    setQuestion('');
    setChatList([]);
    setSessionId('');
    setIsRetryAsk(false);
  };

  return {
    quesText,
    inputValChange,
    onSend,
    onRefresh,
    callAiAsk
  };
};

export default useChatCore;